// 루미아 섬 지도 이미지. 같은 파일 이름(map_v2.png)으로 교체해도 브라우저가 옛 지도를 쓰지 않도록 버전 쿼리를 붙인다.
// 새 지도(2026-04-30, 911x944)는 dak.gg 루트 시뮬레이터의 map_v2.png?q=20260430이고, 지도를 바꾸면 아래 좌표도 함께 바꾼다.
export const MAP_IMAGE_SRC = '/img/map_v2.png?v=20260430';

// 루미아 섬 지도 위의 지역별 위치(%). dak.gg 루트 시뮬레이터(새 지도 기준)에서 추출 (20개 지역, 연구소 제외, 바지선 추가)
const areaPositions = {
  '항구':     { left: 55.19, top: 85.29 },
  '창고':     { left: 41.9, top: 81.2 }, // 시뮬레이터 값(39.74, 85.29)이 구역 경계에 걸려 옛 지도를 정렬한 위치로 조정
  '연못':     { left: 68.43, top: 46.91 },
  '개울':     { left: 79.47, top: 38.38 },
  '모래사장':  { left: 13.25, top: 59.7 },
  '고급 주택가': { left: 24.72, top: 72.49 },
  '골목길':   { left: 53.64, top: 12.79 },
  '주유소':   { left: 35.32, top: 12.79 },
  '호텔':     { left: 13.25, top: 42.64 },
  '경찰서':   { left: 64.02, top: 25.59 },
  '소방서':   { left: 52.98, top: 34.12 },
  '병원':     { left: 88.3, top: 51.17 },
  '절':       { left: 83.89, top: 25.59 },
  '양궁장':   { left: 20.31, top: 23.45 },
  '묘지':     { left: 68.43, top: 59.7 },
  '숲':       { left: 40.3, top: 53.4 }, // 시뮬레이터 값(40.4, 71)이 구역 경계에 걸려 옛 지도를 정렬한 위치로 조정
  '공장':     { left: 83.89, top: 76.76 },
  '성당':     { left: 56.73, top: 68.23 },
  '학교':     { left: 35.32, top: 32.84 },
  '바지선':   { left: 70.64, top: 89.55 },
};

export default areaPositions;
